import { render, staticRenderFns } from "./highAuth.vue?vue&type=template&id=2a222351&scoped=true"
import script from "./highAuth.vue?vue&type=script&lang=js"
export * from "./highAuth.vue?vue&type=script&lang=js"
import style0 from "./highAuth.vue?vue&type=style&index=0&id=2a222351&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a222351",
  null
  
)

export default component.exports